// The device as the UI may hold it. The canonical Device (packages/contracts) is the authority;
// an issued bootstrap's SIP identity and password go only to the call engine, never into UI state.
import type { Device } from '@bcio-voice/contracts';

export type DeviceView = Omit<Device, 'bootstrap'> & {
  bootstrap?: { status: 'unconfigured'; reason_code: string } | { status: 'issued'; expires_at: string };
};

export function redactDevice(device: Device): DeviceView {
  const { bootstrap, ...rest } = device;
  if (!bootstrap) return rest;
  return { ...rest, bootstrap: bootstrap.status === 'issued' ? { status: 'issued', expires_at: bootstrap.expires_at } : { status: 'unconfigured', reason_code: bootstrap.reason_code } };
}
